<procure-card class="page-deleted">
  <p class="page-deleted__text">
    This page has been deleted from ABB Procure. Please reach out to support for further information.
  </p>
  <div class="page-deleted__actions">
    <button
      class="page-deleted__button"
      procure-button
      [routerLink]="redirectUrl"
    >
      {{ redirectLabel }}
    </button>
  </div>
</procure-card>
